<button
    matRipple
    class="dian-button"
    [attr.tabindex]="0"
    (keypress.enter)="onClick()"
    (click)="onClick()"
    [disabled]="disabled"
    [class]="type"
    [class.error]="hasError">
        @if(iconLeft){
            <span class="icon" inline="true" class="icon" >{{iconLeft}}</span>
        }

        <span class="button-label" [class]="size">{{label}}</span>
        @if(iconRight){
            <span class="icon" inline="true"  class="icon" >{{iconRight}}</span>
        }

</button>
